<template>
  <!-- The one composition every pre-auth view shares: a brand-tinted page,
       a theme toggle in the corner, ONE centred card, and the help/legal
       strip under it. The views used to carry their own copies of the glows
       and footnote; the strip and the toggle now come for free. -->
  <div class="sh-page">
    <div class="sh-page__glow sh-page__glow--one" aria-hidden="true"></div>
    <div v-if="wide" class="sh-page__glow sh-page__glow--two" aria-hidden="true"></div>

    <button
      type="button"
      class="sh-page__theme"
      :aria-label="darkMode ? 'Switch to light theme' : 'Switch to dark theme'"
      :title="darkMode ? 'Light theme' : 'Dark theme'"
      @click="toggleTheme"
    >
      <Transition name="sh-icon-swap" mode="out-in">
        <v-icon :key="darkMode ? 'sun' : 'moon'" size="18">{{ darkMode ? "light_mode" : "dark_mode" }}</v-icon>
      </Transition>
    </button>

    <div class="sh-card" :class="[{ 'sh-card--wide': wide }, cardClass]">
      <slot />
    </div>

    <PreAuthFooter v-if="footer" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PreAuthFooter from "./PreAuthFooter.vue";
import { useThemeToggle } from "./useThemeToggle";

export default defineComponent({
  name: "PreAuthPage",
  components: { PreAuthFooter },
  props: {
    /** Login + OrgPicker use the wider card and the second glow. */
    wide: { type: Boolean, default: false },
    /** Off for a page with no resolved tenant (nothing to link to). */
    footer: { type: Boolean, default: true },
    cardClass: { type: [String, Array, Object], default: "" },
  },
  setup() {
    return useThemeToggle();
  },
});
</script>
